import { useState } from 'react';
import { useMinistryTeamStore } from '../../../../../store/ministryTeamStore';
import { deleteMinistryTeam as deleteMinistryTeamApi, getMinistryTeams } from '../apis/ministryTeam-apis';

/**
 * 사역팀 삭제 관련 로직을 관리하는 커스텀 훅
 */
export const useDeleteMinistryTeam = () => {
  const { setMinistryTeams } = useMinistryTeamStore();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string>('');

  /**
   * 사역팀 삭제 및 DB 동기화
   * @param ministryTeamId 삭제할 사역팀의 id
   * @returns Promise<void> - 성공 시 resolve, 실패 시 reject
   */
  const deleteMinistryTeam = async (ministryTeamId: number): Promise<void> => {
    if (isDeleting || !ministryTeamId) {
      return Promise.reject(new Error('이미 삭제 중이거나 유효하지 않은 ID입니다.'));
    }

    setIsDeleting(true);
    setError('');

    try {
      // DB에서 삭제
      await deleteMinistryTeamApi(ministryTeamId);

      // DB에서 최신 리스트 가져오기
      const updatedMinistryTeams = await getMinistryTeams();

      // 스토어 업데이트
      setMinistryTeams(updatedMinistryTeams);
    } catch (err) {
      const errorMessage = '사역팀 삭제 중 오류가 발생했습니다. 다시 시도해주세요.';
      console.error('사역팀 삭제 중 오류 발생:', err);
      setError(errorMessage);
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteMinistryTeam,
    isDeleting,
    error,
    clearError: () => setError(''),
  };
};

